import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './XLproduct.css';

const XLproduct: React.FC = () => {
  return (
    <div className="xl-product-container">
      <Header />

      <section className="xl-product-hero">
        <h2 className="xl-product-title">我们的产品</h2>
        <div className="xl-product-icon-wrapper">
          <div className="xl-product-icon">

            <img src={`${process.env.PUBLIC_URL}/image/xd-logo128-20260601.ico`} alt="序列·生产力平台" />
          </div>
          <div className="xl-product-icon-label">序点-生产力平台</div>
        </div>
      </section>

      <section className="xl-product-grid">
        <div className="xl-product-grid-inner">
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>客服生产力</h3>
            <p>
              覆盖灵活的多轮对话、文档问答等能力的客服机器人，以及覆盖钉钉、企微、官网、小程序等渠道的客户沟通能力。
            </p>
          </div>
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>医疗生产力</h3>
            <p>
              可提供专业的患者病情采集，随时可得的分诊导诊。
            </p>
          </div>
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>智能体</h3>
            <p>
              高度灵活的智能体配置，多种底层大模型适配，多种场景的智能体方案，及时的智能体调试和详细的运行日志。
            </p>
          </div>
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>可控流程</h3>
            <p>
              简便易用的流程，可大幅降低配置门槛，完善的逻辑功能能实现各类复杂的业务逻辑，最终保障智能方案按预期呈现。
            </p>
          </div>
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>多种智能能力</h3>
            <p>
              提供灵活可靠的意图识别能力，覆盖行业领域的实体识别能力以及灵活的扩展能力和完善的工具、技能体系。
            </p>
          </div>
          <div className="xl-product-card">
            <div className="xl-product-star">★</div>
            <h3>质控管理</h3>
            <p>
              具备多场景、多层级的评测体系，提供即时的评测保障，具备贴合业务的打标系统，能够为各类业务提供所需的评测支撑，保障受控的AI生产力释放。
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="xl-product-cta">
        <div className="xl-product-cta-inner">
          <h2>立即体验我们的智能客服系统</h2>
          <p>
            了解我们如何通过创新的AI客服系统来提升您的客户体验。立即行动，让我们为您提供更高效的解决方案。
          </p>
          <div className="xl-cta-buttons">
            <a href="/about" className="xl-cta-btn xl-cta-btn-secondary">了解更多</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default XLproduct;
